import _styled from '@emotion/styled/base';
import { spacing, border } from '@hubble/tokens/web';
import * as CoachMarkPrimitive from '@radix-ui/react-popover';

const CoachMarkContentStyles = _styled(CoachMarkPrimitive.Content, {
  target: "ey4f6dk1"
})("display:flex;flex-direction:column;padding:", spacing[12], ";border-radius:", border.radius.sm, ";z-index:9989;background-color:", ({
  theme
}) => theme.colorScheme.status.bold.background.neutral, ";color:", ({
  theme
}) => theme.colorScheme.status.bold.content.neutral, ";");
const CoachMarkArrowStyles = _styled(CoachMarkPrimitive.Arrow, {
  target: "ey4f6dk0"
})("z-index:10000;fill:", ({
  theme
}) => theme.colorScheme.status.bold.background.neutral, ";");

export { CoachMarkArrowStyles, CoachMarkContentStyles };
